import { gql } from "@apollo/client";

export const generateHostedLens = gql`
    mutation generateHostedLens($lensID: ID!) {
        generateHostedLens(input: { lensId: $lensID }) {
            lens {
                id
                link
                status
                organizationId
            }
        }
    }
`;
